export default __webpack_public_path__ + "static/media/drag.a8fd90b6.svg";